import type { CurrentUserInfo } from '../types'
import { authenticatedFetch } from './auth'
import { clearCachedUserInfo } from './mobilePaymentBarApi'

export async function redeemUltimatePass(cycle: number): Promise<CurrentUserInfo> {
    const response = await authenticatedFetch('/api/mobile-shop/redeemUltimatePass', {
        method: 'POST', body: JSON.stringify({ cycle }),
    })
    const json = await response.json()
    if (!response.ok || json.r !== true || !json.data?.currentUser) {
        throw new Error('Der Gratis-Pass konnte nicht abgeholt werden. Bitte versuche es erneut.')
    }
    clearCachedUserInfo()
    return json.data.currentUser
}
